module.exports = __webpack_public_path__ + "img/7.e6a08c47.png";